import { useLocalStorage } from '@mantine/hooks';

import { useCopilotModel } from 'app/modules/wallforming/components/copilot/hooks/useCopilotModel';

export const useCopilotRequestSettings = (scope: 'chat' | 'plan-to-ifc', defaultTimeout: number) => {
    const modelsQuery = useCopilotModel();
    const [selectedModel, setModel] = useLocalStorage<string>({
        key: `wallforming.copilot.${scope}.model`,
        defaultValue: '',
        getInitialValueInEffect: false
    });
    const [timeout, setTimeout] = useLocalStorage<string>({
        key: `wallforming.copilot.${scope}.timeout`,
        defaultValue: String(defaultTimeout),
        getInitialValueInEffect: false
    });
    const models = modelsQuery.data?.models ?? [];
    const modelWasRemoved = Boolean(selectedModel && !models.includes(selectedModel) && modelsQuery.isSuccess);
    const model = modelWasRemoved ? '' : selectedModel;
    const timeoutSeconds = Number(timeout);
    const isTimeoutValid = /^\d+$/.test(timeout) && timeoutSeconds >= 30 && timeoutSeconds <= 1800;
    const isReady = Boolean(modelsQuery.data?.model) && !modelsQuery.isError;

    return {
        model,
        models,
        defaultModel: modelsQuery.data?.model ?? null,
        modelWasRemoved,
        modelError: modelsQuery.isError || (modelsQuery.isSuccess && !modelsQuery.data.model),
        timeout,
        isTimeoutValid,
        isValid: isReady && (scope === 'plan-to-ifc' || isTimeoutValid),
        setModel,
        setTimeout,
        requestOptions: { ...(model ? { model } : {}), timeoutSeconds }
    };
};
